import { useIntl } from 'react-intl';
import { ConfigurationChangelogVersionEvent } from '@rossum/api-client/configurationChangelog';
import { Typography } from '@rossum/ui/material';
import { formatChangedFields } from './formatChangedFields';

const eventMessageIds = {
  create: 'features.configurationChangelog.rows.objectCreated',
  update: 'features.configurationChangelog.rows.objectUpdated',
  delete: 'features.configurationChangelog.rows.objectDeleted',
} as const satisfies Record<ConfigurationChangelogVersionEvent, string>;

type ChangeSummaryProps = {
  versionEvent: ConfigurationChangelogVersionEvent;
  objectTypeLabel: string;
  fields: string[];
};

export const ChangeSummary = ({
  versionEvent,
  objectTypeLabel,
  fields,
}: ChangeSummaryProps) => {
  const intl = useIntl();

  const label = intl.formatMessage(
    { id: eventMessageIds[versionEvent] },
    { objectType: objectTypeLabel }
  );

  const showFields = versionEvent === 'update' && fields.length > 0;

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        minWidth: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}
    >
      {showFields
        ? `${label}: ${formatChangedFields(fields).join(' • ')}`
        : label}
    </Typography>
  );
};
